import { Expose, Type } from 'class-transformer'
import { ValidateNested } from 'class-validator'
import { Warranty } from '../../entity'

export class WarrantyDTO {
    @Expose()
    @ValidateNested()
    @Type(() => Warranty)
    warranty!: Warranty
}
